export class PaymentMode {
    id: number;
    name: string;
    abbreviation: string;
    observation: string;

    constructor() { }
}

export class PaymentModeForm {
    id: number;
    name: string;
    abbreviation: string;
    observation: string;

    constructor() { }
}